import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import './styles/theme.css';

import '@rainbow-me/rainbowkit/styles.css';
import { 
    chain,
    configureChains,
    createClient,
    WagmiConfig
} from 'wagmi';

import { RainbowKitProvider, connectorsForWallets, AvatarComponent } from '@rainbow-me/rainbowkit';
import {
  injectedWallet,
  rainbowWallet,
  metaMaskWallet,
  coinbaseWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';

import { alchemyProvider } from 'wagmi/providers/alchemy'
import { infuraProvider } from 'wagmi/providers/infura'
import { publicProvider } from 'wagmi/providers/public'
import App from './App';

function CustomAvatar({ address, ensImage, size }) {
    return (
        newFunction(size)
    );
}

const { chains, provider, webSocketProvider } = configureChains(
    [
        chain.mainnet,
        chain.goerli,
        chain.sepolia,
        chain.polygonMumbai,
        chain.optimismKovan,
        chain.arbitrumRinkeby,
        ...(process.env.REACT_APP_ENABLE_TESTNETS === 'true'
            ? [chain.sepolia]
            : []),
    ],
    [
        infuraProvider({ infuraId: process.env.NEXT_PUBLIC_INFURA_ID }),
        alchemyProvider({ alchemyId: process.env.NEXT_PUBLIC_ALCHEMY_ID }),
        publicProvider(),
    ]
);

const connectors = connectorsForWallets([{
    appName: 'Web3 App',
    groupName: 'Recommended',
    wallets: [
        injectedWallet({ chains }),
        rainbowWallet({ chains }),
        metaMaskWallet({ chains }),
        coinbaseWallet({ chains, appName: 'My App' }),
        walletConnectWallet({ chains }),
    ],
  },
]);

const wagmiClient = createClient({
    autoConnect: true,
    connectors,
    provider,
    webSocketProvider,
});

const root = ReactDOM.createRoot(
    document.getElementById('root')
);

const TCATheme = {
    colors: {
        accentColor: '#00fa00',
        accentColorForeground: '#000000',
        actionButtonBorder: 'none',
        actionButtonBorderMobile: 'none',
        actionButtonSecondaryBackground: 'none',
        closeButton: 'none',
        closeButtonBackground: 'none',
        connectButtonBackground: 'none',
        connectButtonBackgroundError: 'none',
        connectButtonInnerBackground: 'none',
        connectButtonText: 'none',
        connectButtonTextError: 'none',
        connectionIndicator: 'none',
        error: 'none',
        generalBorder: 'none',
        generalBorderDim: 'none',
        menuItemBackground: 'none',
        modalBackdrop: 'none',
        modalBackground: '#000000',
        modalBorder: 'none',
        modalText: '#00fa00',
        modalTextDim: 'none',
        modalTextSecondary: 'none',
        profileAction: 'none',
        profileActionHover: 'none',
        profileForeground: 'none',
        selectedOptionBorder: 'none',
        standby: 'none'
    },
    fonts: {
        body: ''
    },
    radii: {
        actionButton: 'none',
        connectButton: 'none',
        menuButton: 'none',
        modal: 'none',
        modalMobile: 'none'
    },
    shadows: {
        connectButton: 'none',
        dialog: 'none',
        profileDetailsAction: 'none',
        selectedOption: 'none',
        selectedWallet: 'none',
        walletLogo: 'none'
    },
    blurs: {
        modalOverlay: ''
    }
};

root.render(
    <React.StrictMode>
        <WagmiConfig client={wagmiClient}>
            <RainbowKitProvider avatar={CustomAvatar} chains={chains} theme={TCATheme}>
                <App />
            </RainbowKitProvider>
        </WagmiConfig>
    </React.StrictMode>
);

function newFunction(size) {
    return <img
        src="/logo192.png"
        width="40"
        height="40"
        style={{ borderRadius: 999, maxWidth: '95px', width: '100%' }} />;
}

